<template>
    <div id="advert-data">
        <div class="breadcrumb">
            <span>信息流广告 ></span>
            <span>{{advertTitle}}的信息流广告 ></span>
            <span>广告详情</span>
            <span>
                <el-button class="right_f" type="primary" @click="cancel">返回</el-button>
            </span>
        </div>
        <div class="advert-detail">
            <div class="detail-item">
                <span>广告标题：{{title}}</span>
            </div>
            <div class="detail-item">
                <span>广告说明：{{description}}</span>
            </div>
            <div class="detail-item">
                <span>图 片：</span>
                <img :src="imageUrl">
            </div>
            <div class="detail-item">
                <span>曝光数：{{exposure}}</span>
            </div>
            <div class="detail-item">
                <span>点击人数：{{clickUserCount}}</span>
            </div>
            <div class="detail-item">
                <span>点击数：{{clickCount}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                advertType: 0,
                advertTitle: '',
                id: '',
                title: '',
                description: '',
                imageUrl: '',
                exposure: '',
                clickUserCount: '',
                clickCount: '',
            }
        },
        mounted() {
            this.advertType = this.$util.getUrlParam('advertType');
            this.id = this.$util.getUrlParam('id');

            if (this.advertType == '0') {
                this.advertTitle = '动态';
            } else if (this.advertType == 1) {
                this.advertTitle = '文章';
            } else if (this.advertType == 2) {
                this.advertTitle = '话题';
            } else {
                this.advertTitle = '通知';
            }

            this.getPvClickData();
        },
        methods: {
            getPvClickData() {
                let url = this.$util.domain + '/information/stream/adData/' + this.id
                this.$http({
                    method: 'GET',
                    url: url,
                }).then(response => {
                    if (response.data.error === 10000) {
                        this.title = response.data.data.title;
                        this.description = response.data.data.description;
                        this.imageUrl = response.data.data.imageUrl;
                        this.exposure = response.data.data.exposure;
                        this.clickUserCount = response.data.data.clickUserCount;
                        this.clickCount = response.data.data.clickCount;
                    } else {
                        this.$util.errorMsg('请求失败');
                    }
                })
            },
            cancel() {
                history.go(-1);
            }
        }
    }
</script>
<style scoped>
    .advert-detail {
        padding: 20px 56px;
    }

    .detail-item {
        margin-bottom: 15px;
    }

    .detail-item img{
        width: 300px;
    }
</style>


// WEBPACK FOOTER //
// advertData.vue?53d39360